import Base from '../base.js'
// import { statusResponse } from '../responseService'
export default class Module extends Base {
  constructor () {
    super('/modules')
  }
}
